import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AlgebraQuest = () => {
  const navigate = useNavigate();
  const [score, setScore] = useState(0);
  const [question, setQuestion] = useState(null);
  const [userAnswer, setUserAnswer] = useState('');
  const [feedback, setFeedback] = useState('');
  const [questsSolved, setQuestsSolved] = useState(0);

  const generateQuestion = () => {
    const types = [
      { q: "If x = 5, what is 3x + 2?", a: 17 },
      { q: "If x = 4, what is 2x - 3?", a: 5 },
      { q: "Solve: x + 7 = 15", a: 8 },
      { q: "Solve: 3y = 21", a: 7 },
      { q: "Solve: x - 5 = 10", a: 15 },
      { q: "If a = 6, what is 4a?", a: 24 },
      { q: "Simplify: 2a + 3a", a: "5a" },
      { q: "Solve: 2x + 4 = 12", a: 4 },
      { q: "If y = 8, what is y/2 + 3?", a: 7 },
      { q: "Solve: 5x = 35", a: 7 },
      { q: "Solve: x + 12 = 20", a: 8 },
      { q: "If b = 10, what is 2b - 5?", a: 15 },
      { q: "Simplify: 7x - 3x", a: "4x" },
      { q: "Solve: 4y + 2 = 18", a: 4 },
      { q: "If m = 3, what is 5m + 1?", a: 16 },
      { q: "Solve: x/3 = 4", a: 12 },
    ];
    const q = types[Math.floor(Math.random() * types.length)];
    setQuestion(q);
    setUserAnswer('');
    setFeedback('');
  };

  useEffect(() => {
    generateQuestion();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!question) return;

    const answer = userAnswer.trim().toLowerCase();
    const correct = answer === String(question.a).toLowerCase();

    if (correct) {
      setScore(score + 20);
      setQuestsSolved(questsSolved + 1);
      setFeedback('✅ Quest Complete!');
      setTimeout(generateQuestion, 1500);
    } else {
      setFeedback(`❌ Wrong! Answer: ${question.a}`);
      setTimeout(generateQuestion, 2500);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-700 via-indigo-700 to-blue-600 py-8 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 mb-6 text-white">
          <div className="flex justify-between items-center">
            <button onClick={() => navigate('/games')} className="hover:text-yellow-300">← Back</button>
            <h1 className="text-3xl font-bold">🧮 Algebra Quest</h1>
            <div className="text-2xl font-bold">{score} pts</div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-2xl p-8">
          <div className="text-center mb-8">
            <div className="text-6xl mb-4">🗡️</div>
            <h2 className="text-2xl font-bold text-gray-800">Solve Algebraic Equations!</h2>
            <p className="text-gray-600">Quests Solved: {questsSolved}</p>
          </div>

          {question && (
            <div className="text-center">
              <div className="text-2xl font-bold text-purple-700 mb-6">{question.q}</div>
              <form onSubmit={handleSubmit} className="max-w-md mx-auto">
                <input
                  type="text"
                  value={userAnswer}
                  onChange={(e) => setUserAnswer(e.target.value)}
                  className="w-full text-4xl text-center border-4 border-purple-300 rounded-lg p-4 mb-4 focus:border-purple-500 focus:outline-none"
                  placeholder="?"
                  autoFocus
                />
                <button type="submit" className="w-full bg-purple-600 text-white text-xl font-bold py-4 rounded-lg hover:bg-purple-700">
                  Solve Quest!
                </button>
              </form>
              {feedback && (
                <div className={`mt-4 text-xl font-bold ${feedback.includes('✅') ? 'text-green-600' : 'text-red-600'}`}>
                  {feedback}
                </div>
              )}
            </div>
          )}

          <div className="mt-8 p-4 bg-purple-50 rounded-lg text-sm">
            <p><strong>💡 Algebra Tips:</strong></p>
            <p>• Variables (x, y, a) represent unknown numbers</p>
            <p>• To solve equations, isolate the variable</p>
            <p>• What you do to one side, do to the other</p>
            <p>• Combine like terms: 2a + 3a = 5a</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlgebraQuest;